<template>
    <div class="header" :style="{fontSize: isPhone ? '12px': ''}">
        <img src="https://cosimg.cdbost.cn/cdboost/sy/logo.png" alt="" class="logo">
        <img src="https://cosimg.cdbost.cn/cdboost/navbar.png" alt="" v-if="isPhone" class="navbar" @click="show">
        <ul class="nav" :class="{navPhone: isPhone}" v-if="showNav">
            <li v-for="(item, index) in navList" :key="item.link" :class="{active: index === tabIndex}"  @click="changeTab(index, item)">
                {{item.text}}
            </li>
        </ul>
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";

    export default {
        name: "header",
        data(){
            return {
                navList: [
                    {text: '首页', link: 'Index'},
                    {text: '解决方案', link: 'solution'},
                    {text: '产品及服务', link: 'service'},
                    {text: '合作加盟', link: 'cooperativeAlliance'},
                    {text: '关于我们', link: 'about'},
                    {text: '智慧云平台', link: 'https://cdz.cdboost.cn/', isCloud: true},
                ],
                isPhone: true,
                isShow: false
            }
        },
        props: ['tabIndex'],
        methods: {
            changeTab(index, item){
                this.isShow = false;
                if(item.isCloud) {
                    window.open(item.link);
                    return
                }
                this.$emit('jump', item.link, index)
            },
            show(){
                this.isShow = !this.isShow
            }
        },
        computed: {
            showNav(){
                if(!this.isPhone){
                    return true;
                }else{
                    return this.isShow
                }
            }
        },
        created() {
            this.isPhone = getPCorPhone();
            this.isShow = !this.isPhone
            console.log(this.isPhone)
        }
    }
</script>

<style scoped  lang="scss">
$height: 4em;
.header{
    background: #12335C;
    color: white;
    height: $height;
    position: relative;
    width: 80%;
    top: 0;
    left: 0;
    z-index: 1;
	padding: 0 10%;
    .logo{
        height: 2.5em;
        margin: 0.75em 0 0 1em;
    }
    .navbar{
        float: right;
        height: 2.5em;
        margin: 1em 1em 0 0;
        cursor: pointer;
    }
    .nav{
        float: right;
        height: 100%;
        li{
            float: left;
            line-height: $height;
            height: $height;
            font-size: 1em;
	        padding: 0 1em;
            cursor: pointer;
            position: relative;
	        margin: 0 0.5em;
            span{
                font-size: 1em;
            }
            &:hover:after{
	            content: '';
	            position: absolute;
	            width: 100%;
	            height: 0.2em;
	            background: white;
	            bottom: 0;
	            left: 0;
            }
        }
        .active:after{
            content: '';
            position: absolute;
            width: 100%;
            height: 0.2em;
            background: white;
            bottom: 0;
            left: 0;
        }
    }
    .navPhone{
        background-color: rgba(18, 51, 92, 0.8);
        position: absolute;
        left: 0;
        width: 100%;
        top: 5em;
        float: none;
        height: 30em;
        border-bottom: none;
        li{
            float: none;
            text-indent: 1em;
            &:hover{
                color: #35B0D1;
            }
            &:after{
                display: none;
            }
            &:focus-visible{
                background: none;
            }
        }
        .active{
            color: #35B0D1;
            border: none;
        }
    }
}
</style>